import React, { useEffect, useState } from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import { PaginationModel } from 'utils/PaginationType';
import ShireTable from 'components/ShireTable';
import { deleteCategory, getCategories } from 'services/ProductService';
import { CategoryDefaultValues, CategoryTableColumns } from './ProductModel';
import { Category } from './ProductType';
import { CategoryModal } from './CategoryModal';

const CategoryManagement = React.memo(() => {
    const [open, setOpen] = useState(false);
    const [paginationModel, setPaginationModel] = useState<PaginationModel>({
      page: 0,
      pageSize: 10,
      rowCount: 0,
    });
    const [categories, setCategories] = useState<Category[]>([]);
    const [totalCategories, setTotalCategories] = useState(0);
    const [initialValues, setInitialValues] = useState<Category>({...CategoryDefaultValues});
    const [isEdit, setIsEdit] = useState(false);
  
    useEffect(() => {
      fetchCategories(paginationModel.page + 1, paginationModel.pageSize);
    }, []);
  
    const fetchCategories = async (page: number, pageSize: number) => {
      const response = await getCategories(page, pageSize);
      setCategories(response.records);
      setTotalCategories(response.total);
    };
  
    const handleSubmit = async () => {
      await fetchCategories(paginationModel.page + 1, paginationModel.pageSize);
      setOpen(false);
      setInitialValues({...CategoryDefaultValues});
    };

    const handleClose = () => {
      setOpen(false);
      setIsEdit(false);
      setInitialValues({...CategoryDefaultValues});
    };

    const handleEdit = (category: Category) => {
      setOpen(true);
      setInitialValues(category);
      setIsEdit(true);
    };

    const handleDelete = async (category: Category) => {
      await deleteCategory(category.id);
      await fetchCategories(paginationModel.page + 1, paginationModel.pageSize);
    }
  
    return <>
    <Typography variant="h4" sx={{ marginBottom: 3 }}>Quản lý danh mục</Typography>
    <Paper elevation={3} sx={{ padding: 2 }}>
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 2 }}>
      <Button variant="contained" color="primary" onClick={() => setOpen(true)}>
        Thêm mới danh mục
      </Button> 
    </Box>
    <ShireTable
      columns={CategoryTableColumns(fetchCategories, paginationModel, handleEdit, handleDelete)}
      rows={categories}
      paginationModel={{
        page: paginationModel.page,
        pageSize: paginationModel.pageSize,
        rowCount: totalCategories,
      }}
      onPaginationModelChange={setPaginationModel}
    />
    <CategoryModal
      open={open}
      onClose={handleClose}
      onSubmit={handleSubmit}
      initialValues={initialValues}
      isEdit={isEdit}
    />
    </Paper>
    </>;
});

export default CategoryManagement;